/* eslint-disable @typescript-eslint/no-explicit-any */
import { toast } from 'react-toastify'
import { Action, Store } from 'redux'
import { ThunkAction } from 'redux-thunk'
import { EXAM_URL } from '../../service/apiEndPoints'
import { apiCall, METHOD } from '../../service/baseApiCall'
import {
  ATTEND_EXAM,
  START_EXAM,
  SUBMIT_EXAM,
  UPDATE_QUESTION,
  SAVE_QUESTION_STATUS,
} from '../constants/action-types'

// ************** SET_ATTEND_EXAM_DATA ******************
export const setAttendExamData =
  (res: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: ATTEND_EXAM.SET_ATTEND_EXAM_DATA,
      payload: { examData: res },
    })
  }

// ************** START_EXAM ******************

export const startExam =
  (
    id: string | undefined,
    _handleRedirect: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(startExamInit(id, _handleRedirect))
  }

export const startExamInit =
  (
    id: string | undefined,
    _handleRedirect: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: START_EXAM.START_EXAM_INITIALIZATION,
    })
    apiCall(
      `${EXAM_URL}${id}/start_exam`,
      (res: any) => dispatch(startExamSuccess(res, _handleRedirect)),
      (err: any) => {
        dispatch(startExamError(err))
      },
      {},
      METHOD.POST,
      { showToast: true }
    )
  }

export const startExamSuccess =
  (
    res: any,
    _handleRedirect: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: START_EXAM.START_EXAM_SUCCESS,
      payload: res.data,
    })
    _handleRedirect()
  }

export const startExamError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: START_EXAM.START_EXAM_ERROR,
      payload: err.message,
    })
    toast.error(err?.data?.message?.exam[0])
  }

// ************** SET_UPDATE_QUESTION ******************
export const setUpdatedQuestion =
  (res: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: UPDATE_QUESTION.SET_QUESTION,
      payload: res,
    })
  }

// ************** SUBMIT_EXAM ******************

export const submitExam =
  (
    id: string | undefined,
    payload,
    _handelRedirect?: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(submitExamInit(id, payload, _handelRedirect))
  }

export const submitExamInit =
  (
    id: string | undefined,
    payload,
    _handelRedirect?: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: SUBMIT_EXAM.SUBMIT_EXAM_INITIALIZATION,
    })
    apiCall(
      `${EXAM_URL}${id}/submit`,
      (res: any) => dispatch(submitExamSuccess(res, _handelRedirect)),
      (err: any) => {
        dispatch(submitExamError(err))
      },
      payload,
      METHOD.POST,
      {}
    )
  }

export const submitExamSuccess =
  (
    res: any,
    _handelRedirect?: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: SUBMIT_EXAM.SUBMIT_EXAM_SUCCESS,
      payload: res.data,
    })
    if (_handelRedirect) {
      _handelRedirect()
    }
  }

export const submitExamError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: SUBMIT_EXAM.SUBMIT_EXAM_ERROR,
      payload: err.message,
    })
  }

// To save question status
export const questionStatusSave =
  (data: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: SAVE_QUESTION_STATUS.SAVE_QUESTION_SUCCESS,
      payload: data,
    })
  }
